// @ngInject
const TechniqueDialogService = ($mdDialog) => ({
  showDialog: (options = {}) =>
    $mdDialog.show({
      clickOutsideToClose: true,
      controller: 'TechniqueDialogController as vm',
      templateUrl: 'services/dialogs/techniqueDialog/techniqueDialog.tpl.html',
      locals: Object.assign(
        {
          technique: null,
          displayOrder: false,
          checkedByDefault: false,
          vdcSupport: true,
          archivable: true,
          allowedToEdit: true,
        },
        options,
      ),
    }),
});

class TechniqueDialogController {
  constructor(
    $mdDialog,
    toasterService,
    technique,
    onSave,
    displayOrder,
    checkedByDefault,
    vdcSupport,
    archivable,
    allowedToEdit,
  ) {
    'ngInject';

    this.$mdDialog = $mdDialog;
    this.toasterService = toasterService;

    this.validationErrors = [];
    this.onSave = onSave;
    this.displayOrder = displayOrder;
    this.checkedByDefault = checkedByDefault;
    this.vdcSupport = vdcSupport;
    this.archivable = archivable;
    this.allowedToEdit = allowedToEdit;
    this.editMode = technique !== null;

    if (!this.editMode) {
      technique = {};
    }
    this.technique = _.extend({}, technique);
  }

  save() {
    this.validationErrors = [];
    this.$mdDialog.startLoadingSpinner();
    this.onSave(this.technique)
      .then(
        () => {
          this.toasterService.success();
          this.$mdDialog.hide();
        },
        (error) => {
          this.validationErrors = error.errors;
        },
      )
      .finally(() => {
        this.$mdDialog.stopLoadingSpinner();
      });
  }

  archive() {
    this.technique.archived = !this.technique.archived;
    this.save();
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}

angular
  .module('services.dialogs.techniqueDialog', [])
  .service('TechniqueDialogService', TechniqueDialogService)
  .controller('TechniqueDialogController', TechniqueDialogController);
